package ui.eReceipt.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.semantics.clearAndSetSemantics
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import receipt.Receipt
import toContentDescription
import ui.Colors

@Composable
fun LocationTitleBanner(
    locationDetails: Receipt.LocationDetails,
    maxWidth: Dp,
) {
    val storeName = locationDetails.name
    val storeAddress = locationDetails.address
    val phoneNumber = locationDetails.phoneNumber
    Box(
        modifier = Modifier
            .background(Colors.EreceiptGreen)
            .widthIn(0.dp, maxWidth)
            .clearAndSetSemantics {
                contentDescription = toContentDescription(
                    storeName,
                    storeAddress,
                    phoneNumber
                )
            }
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(vertical = 16.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Text(
                storeName,
                fontSize = 28.sp,
                color = Color.Black,
                textAlign = TextAlign.Center
            )
            Spacer(modifier = Modifier.height(4.dp))
            Text(
                storeAddress,
                color = Color.Black,
                fontSize = 20.sp,
                textAlign = TextAlign.Center
            )
            Spacer(modifier = Modifier.height(4.dp))
            Text(
                phoneNumber,
                color = Color.Black
            )
        }
    }
}